import { useState } from 'react'

import { useNavigate } from 'react-router-dom'
import { useProfileStore } from 'Store/Profile'
import { shallow } from 'zustand/shallow'

import { TABS } from '../Config'
import Notification from 'Data/notification'

const VIEW_INDEX = 8

const ViewModel = () => {
	const navigate = useNavigate()
	const [data] = useState(Notification)
	const profile = useProfileStore(state => state.profile, shallow)

	const findTabPath = (tabIndex: number) => {
		const tab = TABS.find((_, idx) => idx === tabIndex)
		if (tab) {
			return tab.path
		}
	}

	const onChangeTab = (tabIndex: number) => {
		if (tabIndex !== VIEW_INDEX) {
			navigate(findTabPath(tabIndex) ?? '#')
		}
	}

	return {
		companyName: profile?.companyName ?? '',
		data,
		currentTab: VIEW_INDEX,
		onChangeTab,
	}
}

export default ViewModel
